<template>
  <UiFormAsyncSelect
    :id="id"
    v-model="model"
    :mode="mode"
    :label="labelField"
    :value-prop="valueField"
    :placeholder="placeholder"
    :searchable="true"
    :caching="false"
    :filter-results="false"
    :min-chars="0"
    :delay="300"
    :async-source="locationsSource"
    v-bind="$attrs">
    <!-- Custom option display with location name, address, and account -->
    <template #option="{ option }">
      <div class="flex flex-col">
        <div>
          <span class="font-medium">{{ option.name }}</span>
          <span v-if="option.accountName" class="text-gray-500 text-sm ml-1">
            ({{ option.accountName }})
          </span>
        </div>
        <span v-if="option.address" class="text-sm text-gray-500">{{ option.address }}</span>
      </div>
    </template>

    <!-- Custom single value display -->
    <template #singleLabel="{ value }">
      <div class="flex flex-col">
        <div>
          <span class="font-medium">{{ value.name }}</span>
          <span v-if="value.accountName" class="text-gray-500 text-xs ml-1">
            ({{ value.accountName }})
          </span>
        </div>
        <span v-if="value.address" class="text-xs text-gray-500">{{ value.address }}</span>
      </div>
    </template>

    <!-- Pass through other slots -->
    <template v-for="(_, slotName) in $slots" #[slotName]="slotData">
      <slot :name="slotName" v-bind="slotData" />
    </template>
  </UiFormAsyncSelect>
</template>

<script setup>
import { computed } from 'vue'
import { UiFormAsyncSelect } from '@ui/form/async_select'

const props = defineProps({
  modelValue: {
    type: [String, Array, Number],
    default: null
  },
  id: {
    type: String,
    default: 'location-select'
  },
  mode: {
    type: String,
    default: 'single' // single or tags
  },
  placeholder: {
    type: String,
    default: 'Select or type to search locations...'
  },
  // API configuration
  apiFunction: {
    type: Function,
    required: true
  },
  labelField: {
    type: String,
    default: 'name'
  },
  valueField: {
    type: String,
    default: 'id'
  }
})

const emit = defineEmits(['update:modelValue'])

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const locationsSource = async (search) => {
  search = search?.trim() || ''
  try {
    const { data } = await props.apiFunction({ search: search })
    return (data ?? [])
  } catch (error) {
    console.error('Failed to load locations:', error)
    throw error
  }
}

</script>
